import { Routes } from "@angular/router";
import { MainComponent } from "./layout/main/main.component";
import { AuthLayoutComponent } from "./layout/auth-layout/auth-layout.component";
import { AuthGuardFxn } from "./core/guards/auth.guard";

export const routes: Routes = [
  // {
  //   path: "",
  //   pathMatch: "full",
  //   redirectTo: "auth"
  // },
  {
    path: "auth",
    component: AuthLayoutComponent,
    canActivate: [AuthGuardFxn],
    loadChildren: () => import("./modules/auth/auth.routes").then((m) => m.routes),
  },
  {
    path: "",
    component: MainComponent,
    canActivate: [AuthGuardFxn],
    loadChildren: () => import("./modules/afterLoginpages/module-routes").then((m) => m.routes),
  },
];
